import * as React from 'react';
import Image from 'next/image';

import cx from 'classnames';

import { Background } from './Background/Background';
import { ClassicFooter } from './ClassicFooter';
import { SalonHeading } from './SalonHeading';

import c from './ClassicLayout.module.css';
import s from './ClassicMinimalLayout.module.css';

type Props = {
  hideBackground?: boolean;
  children: React.ReactNode;
};

export const ClassicMinimalLayout = ({ children, hideBackground }: Props) => (
  <div className={cx(s.root, c.classic)}>
    <div className={s.page}>
      {hideBackground ? null : <Background />}
      <header className={s.header}>
        <div className={s.desktopLogo}>
          <a href="https://glossgenius.com">
            <Image
              src="/assets/logos/GG_Logo_White.svg"
              width="163"
              height="17"
              alt="GlossGenius"
            />
          </a>
        </div>
        <SalonHeading className={s.salonHeading} />
      </header>
      <main className={s.container}>{children}</main>
      <div className={s.footerContainer}>
        <ClassicFooter />
      </div>
    </div>
  </div>
);
